declare const Pusher: any;

import { Injectable } from '@angular/core';
import { AppSettings } from '../app.settings';

@Injectable({
  providedIn: 'root'
})
export class PusherService {

  pusher: any;
      channel: any;
      constructor() {
        this.pusher = new Pusher(AppSettings.PUSHER_SETTINGS.key, {
          cluster: AppSettings.PUSHER_SETTINGS.cluster,
          encrypted: true
        });
        this.channel = this.pusher.subscribe('sms-entries-channel');
      }

}
